<template lang="pug">
v-card
  v-card-title
    .subtitle-1 Export PNG

  v-card-text
    p Each card will be exported as an individual PNG at 288 DPI, bundled into a zip file.

    v-label
      strong Which Components?
    v-divider

    component-selector(:game="game")

  v-card-actions
    v-spacer
    v-btn(text @click="$emit('close-dialog')") Cancel
    v-btn(color="primary" @click="confirm")
      v-icon(left small) mdi-image-multiple
      | Export PNG
</template>

<script>
import ComponentSelector from './ComponentSelector.vue'

export default {
  components: { ComponentSelector },

  props: ['game'],

  methods: {
    confirm() {
      this.$emit('confirm')
      this.$emit('close-dialog')
    },
  },
}
</script>
